import React, { useEffect, useState } from "react"
import DataGrid from "../../components/DataGrid/DataGrid"
import { Box, styled, Typography } from "@mui/material"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import { useDispatch } from "react-redux"
import { showProductionReceptionToReceive } from "../../actions/ProductionReception/ProductionReception"
import { generateOrderUnitLabel } from "../../utils/ordersUtils"
import { hasProductionSupplyStocks } from "../../utils/productionStepExecution"
import { COLORS } from "../../utils"

const disableRow = (productionSupply) => productionSupply.weights?.output === 0

const StyledContainer = styled("span", {
    shouldForwardProp: (prop) => prop !== "isError"
})((props) => {
    if (props.isError) {
        return {
            color: "#F44259",
        }
    }
    return {}
})

const ProductionReceptionToDo = ({ productionSupplies }) => {
    console.log("productionSupplies", productionSupplies)
    const dispatch = useDispatch()
    const [data, setData] = useState([])

    useEffect(() => {
        if (!productionSupplies) return
        const formattedData = productionSupplies.map((productionSupply) => {
            const item = {
                id: productionSupply.objectId,
                name: productionSupply.supplierItem.name,
                quantity: `${productionSupply.outputQuantity}-${generateOrderUnitLabel(productionSupply.supplierItem)}`,
                weights: productionSupply.weights,
                stocks: productionSupply.stocks ? productionSupply.stocks + " kg" : "",
                nextDelivery: productionSupply.nextDelivery,
                disableHover: disableRow(productionSupply)
            }

            return item
        })
        setData(formattedData)
    }, [productionSupplies])

    const columns = [
        {
            key: "name",
            label: "Nom du produit",
            dataType: "text",
            sortable: false,
            filter: {
                filterable: true,
                type: "text",
                fullText: true
            }
        },
        {
            key: "weights",
            label: "Poids sorti / prévu",
            dataType: "text",
            sortable: false,
            filter: {
                filterable: false,
            },
            render: ({ output, expected = 0 }) => {
                return (
                    <div>
                        <Typography>
                            <StyledContainer isError={hasProductionSupplyStocks(output, expected)}>{output}</StyledContainer>
                            &nbsp;<span>/</span>&nbsp;
                            <span>{expected} kg</span>
                        </Typography>
                    </div>
                )
            }
        },
        {
            key: "quantity",
            label: "Quantité  sortie",
            dataType: "text",
            sortable: false,
            filter: {
                filterable: false,
            },
            render: (value) => {
                const quantity = value.split("-")[0]
                const unit = value.split("-")[1]

                if (isNaN(quantity)) return null
                return (
                    <div><span>{quantity}</span><span style={{ color: "#7C7C7C", marginLeft: 1 }}>({unit?.trim()})</span></div>
                )
            }
        },
        {
            key: "stocks",
            label: "Stocks",
            dataType: "text",
            sortable: false,
            filter: {
                filterable: false,
            },
        },
        {
            key: "nextDelivery",
            label: "Prochaine livraison",
            dataType: "text",
            sortable: false,
            filter: {
                filterable: false,
            },
            render: (nextDelivery) => {
                if (!nextDelivery) return null
                const { date, quantity } = nextDelivery

                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography sx={{ color: "#555", marginRight: 1 }}>
                            {date}
                        </Typography>
                        <Typography sx={{ color: COLORS.DRAFT_GREY }}>
                            ({quantity} kg)
                        </Typography>
                    </Box>
                )
            }
        },
    ]

    const handleRowClick = (productionSupply) => {
        if (disableRow(productionSupply)) return
        dispatch(showProductionReceptionToReceive(productionSupply.id))
    }

    return (
        <>
            {data && data.length > 0 ?
                (<DataGrid
                    title={"Produits à réceptionner"}
                    columns={columns}
                    data={data}
                    withFilters={true}
                    rowLabel={null}
                    onRowClick={handleRowClick}
                    withAdditionalFiltersOptions={false}
                    tableContainerStyle={{ boxShadow: "none" }}
                />)
                :
                (
                    <Box sx={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}>
                        <Box sx={{ textAlign: "center" }}>
                            <CheckCircleIcon sx={{ color: "#44b46c", textAlign: "center", width: 52, height: 52 }} />
                        </Box>
                        Tous les produits ont été réceptionnés
                    </Box>
                )
            }
        </>
    )
}

export default ProductionReceptionToDo